export * from './award/award-detail/award-detail/award-detail.component';
export * from './award/award-detail/award-detail.component';
export * from './award/award-detail/award-letter/award-letter.component';
export * from './award/award-list/award-row/award-row.component';
export * from './award/award-list/award-list.component';
export * from './award/award-detail/award-certificate/award-certificate.component';
export * from './award/award-detail/award-contact/award-contact.component';
// export * from "./award/award-detail/"
export * from './award/award';

//LOt
export * from './payment/lot-detail/lot-detail.component';
export * from './payment/lot-payment/lot-payment.component';
export * from './payment/lot-list/lot-row/lot-row.component';
export * from './payment/lot-list/lot-list.component';
export * from './payment/lot';
//Profile
export * from './profile/profile';
export * from './profile/profile-detail/profile-detail.component';
export * from './profile/profile-document/profile-document.component';

//account verification
export * from './account-verification/step1/step1.component';
export * from './account-verification/step2/step2.component';
export * from './account-verification/verification';

//Company
export * from './setting/setting';
export * from './setting/company-detail/profile-detail.component';
export * from './setting/company-document/profile-document.component';

//register-company
export * from './registered-company/registered-company.component';
export * from './registered-company/company-detail/company-detail.component';
export * from './registered-company/company-record/record/record.component';
export * from './registered-company/company-record/row/row.component';
export * from './registered-company/company-document/company-document.component';
export * from './registered-company/company-director/company-director.component';
export * from './registered-company/company-equipment/company-equipment.component';
export * from './registered-company/company-equipment/archived-equipment/archived-equipment.component';
export * from './registered-company/company-equipment/official-equipment/official-equipment.component';
export * from './registered-company/company-user/company-user.component';
export * from './registered-company/company-record/company-record.component';
export * from './registered-company/company-profile/company-profile.component';
export * from './registered-company/company-document/official-document/official-document-list/affiliate-list/official-document-list.component';

//Dashboard
export * from './dashboard/dashboard.component';
export * from './dashboard/dashboard-container.component';
export * from './dashboard/dashboard-inner';
export * from './dashboard/application/application.component';
export * from './dashboard/dashboard-invoice/dashboard-invoice.component';
export * from './dashboard/dashboard-app/dashboard-app.component';
export * from './dashboard/dashboard-record/dashboard-record.component';
export * from './dashboard/dashboard-company/dashboard-company.component';
export * from './dashboard/dashboard-invoice-list/dashboard-invoice-list.component';

//Invoice
export * from './invoice/invoice.component';
export * from './invoice/invoice-list/invoice-list.component';
export * from './invoice/invoice-payment/invoice-list.component';
export * from './invoice/invoice-list/invoice-row/invoice-row.component';
export * from './invoice/invoice-list/invoice-row/invoice-unit.component';
export * from './chat/chat.component';
export * from './chat/message.component';
export * from './chat/message-nested.component';

export * from './account-security/account-security.component';
export * from './notification/notification.component';
export * from './notification/configuration';
//role
//Role
export * from './role/role-list/role-list.component';
export * from './role/role-detail/role-detail.component';
export * from './role/role-new/role-new.component';
export * from './role/role-list/role-row/role-row.component';
export * from './role/role-edit/role-edit.component';

// AOL
export * from './aol/aol-row/aol-row.component';
export * from './aol/aol.component';
export * from './aol/manage-aol/manage-aol.component';
export * from './aol/manage-aol/network-operator-row/network-operator-row.component';
export * from './aol/manage-aol/non-network-operator-row/non-network-operator.component';
export * from './aol/manage-aol/document-upload/document-upload.component';

export * from './registered-company/company-equipment/official-equipment/row/official-equipment-row.component';

// E-Wallet
export * from './e-wallet/e-wallet.component';
export * from './e-wallet/activate-e-wallet/activate-e-wallet.component';
export * from './e-wallet/activating-e-wallet/activating-e-wallet.component';
export * from './e-wallet/accounts/accounts.component';
export * from './e-wallet/accounts/accounts-row/accounts-row.component';
export * from './e-wallet/transactions/transactions.component';
export * from './e-wallet/transactions/transactions-row/transactions-row.component';
export * from './e-wallet/fund-wallet/fund-wallet.component';
export * from './e-wallet/withdrawal-request/withdrawal-request.component';
export * from './e-wallet/withdrawal-request/withdrawal-request-row/withdrawal-request-row.component';
export * from './e-wallet/account-sidebar/account-sidebar.component';
export * from './e-wallet/bank-change-request/bank-change-request.component';
export * from './e-wallet/bank-change-request/bank-change-request-row/bank-change-request-row.component';

// OWNERSHIP STRUCTURE
export * from './registered-company/ownership-structures/ownership-structure.component';
export * from './registered-company/ownership-structures/history/history-structure.component';
export * from './registered-company/ownership-structures/pending-structure/pending-structure.component';
export * from './registered-company/ownership-structures/verified-structure/verified-structurecomponent';
export * from './registered-company/ownership-structures/update-mode/update-mode.component';

export * from './registered-company/company-record/history-record/record.component';
export * from './registered-company/company-record/history-row/row.component';
export * from './registered-company/company-record/verified-record/record.component';
export * from './registered-company/company-record/verified-row/row.component';
